import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IProductResponse } from 'src/app/core/services/payments-api-service';
import { AutocompleteBaseComponent } from "../../../../shared/components/autocomplete/autocomplete-base.component";
import { LanguageRouterLinkDirective } from 'src/app/shared/directives/language-router-link.directive';


export interface CheckoutProduct extends IProductResponse {
  cssClassName?: string,
  benefits?: string
  discount?: number
  titleBanner?: string
  learnMore: boolean,
  learnMoreLink?: string | undefined,
  isSelected:boolean
}
@Component({
  selector: 'product-card',
  templateUrl: './product-card.component.html',
  standalone: true,
  imports: [CommonModule, LanguageRouterLinkDirective],
})
export class ProductCardComponent {
  @Output() onProductSelect = new EventEmitter<CheckoutProduct>();
  @Input() products: CheckoutProduct[] = [];



  selectProduct(product: CheckoutProduct) {
    this.onProductSelect.emit(product);
  }

  constructor() {
  }
}